<template>
  <div>
    <div class="product-container">
      <Bread
        first-name="产品中心"
        metertype="智慧水务"
        meter-name="NB水表"
      ></Bread>
      <div class="top-title">
        <h1>西安星年物联网</h1>
      </div>
      <div class="info">
        <el-row :gutter="16">
          <el-col :span="16">
            <h1>NB-Iot水表（模块）</h1>
            <div class="introduce">
              <div class="title">产品介绍</div>
              <div class="intro-text">
                <p>
                  NB-IOT水表模块是窄带物联网NB-IOT水表的核心部件，NB-IOT水表无需布置基站，传输信号稳定，安全可靠，各大厂商模组质量稳定，NB-IOT水表是无线水表的未来主流发展方向。
                </p>
              </div>
            </div>
            <div class="trait">
              <div class="title">功能特点</div>
              <div class="intro-text">
                <p>
                  1、LCD标准配置，方便查询表计信息；
                </p>
                <p>
                  2、触摸按键设计，长按主动上报，短按查询表计信息；
                </p>
                <p>
                  3、可配置，可设置上报周期，定时上报功能，预留透支量，阀门报警量；
                </p>
                <p>
                  4、防磁，电源电压检测、掉电存储功能；
                </p>
                <p>
                  5、平台中心结算，减轻表端压力；
                </p>
                <p>
                  6、缴费便捷，支持线上后台缴费，移动端小程序缴费；
                </p>
                <p>
                  7、完善的物联网平台查询系统，区域查询，周期查询，报警查询；
                </p>
                <p>
                  8、用户可定制服务。
                </p>
              </div>
            </div>
            <div></div>
          </el-col>
          <el-col :span="8">
            <!-- <div class="meter-img">
              <img src="@/svg/NB.jpg" />
            </div> -->
            <div class="meter-img">
              <img src="@/svg/meter.png" />
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
export default {}
</script>
<style lang="scss" scope>
.box {
  font-size: 42px;
}
.top-title {
  padding: 100px 0 0 0;
  border-bottom: 4px solid #4e56c5;
  h1 {
    color: #4e56c5;
  }
}
.info {
  h1 {
    text-indent: 1cm;
    color: #3ab0e7;
  }
  .introduce {
    padding: 60px 0 0 0;
    .title {
      text-indent: 1cm;
      font-size: 24px;
      color: #3ab0e7;
    }
    .intro-text {
      padding: 20px 0 0 20px;
      text-indent: 1cm;
      line-height: 30px;
    }
  }
  .trait {
    padding: 60px 0 0 0;
    .title {
      text-indent: 1cm;
      font-size: 24px;
      color: #3ab0e7;
    }
    .intro-text {
      padding: 20px 0 0 20px;
      text-indent: 1cm;
      line-height: 30px;
    }
  }
  background-color: #fff;
  margin: 100px 0 0 0;
  .meter-img {
    img {
      width: 370px;
    }
  }
}
</style>
